(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squishyimperium"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const surpriseBags=new WeakMap();
 const animate=(el,hover=false)=>{
 if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const target=el.querySelector('.shape, .toy')||el;
 const direction=Math.random()<.5?-1:1;
 const strength=.85+Math.random()*.3;
 const moves=[
 ['scale(1)','scale(1.24,.69) rotate('+direction*6+'deg)','scale(.88,1.13) rotate('+direction*-4+'deg)','scale(1.05,.95)','scale(1)'],
 ['rotate(0deg)','rotate('+direction*14+'deg) scale(.94,1.06)','rotate('+direction*-11+'deg)','rotate('+direction*6+'deg)','rotate(0deg)'],
 ['translateY(0) scale(1)','translateY(5px) scale(1.12,.85)','translateY('+(-20*strength)+'px) scale(.93,1.08)','translateY(2px) scale(1.08,.91)','translateY(0) scale(1)'],
 ['scale(1) rotate(0deg)','scale(.8,1.17) rotate('+direction*10+'deg)','scale(1.18,.82) rotate('+direction*-8+'deg)','scale(.96,1.04)','scale(1) rotate(0deg)'],
 ['translateX(0) rotate(0deg)','translateX('+direction*9+'px) rotate('+direction*9+'deg)','translateX('+direction*-8+'px) rotate('+direction*-7+'deg)','translateX('+direction*4+'px)','translateX(0) rotate(0deg)']
 ];
 let choice=Math.floor(Math.random()*moves.length);
 if(String(choice)===target.dataset.lastSquish)choice=(choice+1+Math.floor(Math.random()*(moves.length-1)))%moves.length;
 target.dataset.lastSquish=String(choice);
 target.getAnimations().forEach(animation=>animation.cancel());
 target.animate(moves[choice].map(transform=>({transform})),{duration:(hover?750:580)+Math.random()*360,easing:'cubic-bezier(.36,.05,.25,1)',iterations:1});
};
 const hoverTarget=event=>event.target.closest('.si .si-squeeze,.si .toybutton,.si [data-si-filter],.si .si-surprise');
 document.addEventListener('pointerover',event=>{
  if(event.pointerType==='touch'||!matchMedia('(hover:hover)').matches)return;
  const target=hoverTarget(event);
  if(!target||(event.relatedTarget&&target.contains(event.relatedTarget)))return;
  animate(target,true);
 });
 document.addEventListener('focusin',event=>{const target=hoverTarget(event);if(target&&target.matches(':focus-visible'))animate(target,true);});
 document.addEventListener('click',function(event){
 const root=event.target.closest('.si');if(!root)return;
 const toy=event.target.closest('.toybutton');if(toy)animate(toy);
 const cardButton=event.target.closest('.si-squeeze');if(cardButton)animate(cardButton.closest('.card'));
 const filter=event.target.closest('[data-si-filter]');
 if(filter){animate(filter);root.querySelectorAll('[data-si-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filter)));let count=0;root.querySelectorAll('[data-si-category]').forEach(card=>{card.hidden=filter.dataset.siFilter!=='all'&&card.dataset.siCategory!==filter.dataset.siFilter;if(!card.hidden)count++;card.classList.remove('picked');});root.querySelector('.si-status').textContent=count+' collection preview'+(count===1?'':'s');}
 if(event.target.closest('.si-surprise')){animate(event.target.closest('.si-surprise'));const cards=Array.from(root.querySelectorAll('[data-si-category]')).filter(c=>!c.hidden);if(!cards.length)return;root.querySelectorAll('.picked').forEach(c=>c.classList.remove('picked'));let state=surpriseBags.get(root);
if(!state||state.cards.length!==cards.length||state.cards.some((card,i)=>card!==cards[i])){state={cards:[...cards],bag:[]};surpriseBags.set(root,state);}
if(!state.bag.length){state.bag=[...cards];for(let i=state.bag.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[state.bag[i],state.bag[j]]=[state.bag[j],state.bag[i]];}}
const selected=state.bag.pop();selected.classList.add('picked');animate(selected);root.querySelector('.si-status').textContent='Your surprise pick: '+selected.dataset.siName;selected.querySelector('button').focus({preventScroll:true});}
});
})();

  } catch(e) { console.error(e); }
})();
})();
